import React, { useState, useEffect} from 'react';
import ReactFullpage from '@fullpage/react-fullpage';
import ImageSection from './ImageSection';
import { useDispatch, useSelector } from "react-redux";
import { allPagesNumbers, handleDesktopImageCount, handleMobileImageCount } from './redux/actions';
// import Slider from "react-slick";
// import 'slick-carousel/slick/slick.css';
// import 'slick-carousel/slick/slick-theme.css';
import GetInTouch from './components/GetInTouch';
import TeamMember from './components/TeamMember';

const Fullpage = () => {
  const [madhyaImages, setMadhyaImages] = useState([]);
  const [initialPageNo, setInitialPageNo] = useState([]);
  const [fullpageInstance, setFullpageInstance] = useState(null);

  const dispatch = useDispatch();
  const pageNos = useSelector(state => state.pageNo);
  const pageNumber = pageNos[pageNos.length - 1];

  // useEffect(() => {

  //   const fetchData = async () => {
  //     try {
  //       const response = await fetch("http://localhost:8000/api/frontend/get-all-data");
  //       const data = await response.json();
  //       setMadhyaImages(data);
  //       setTimeout(() => {
  //         window.dispatchEvent(new Event('resize'));
  //         if (window.fullpage_api) window.fullpage_api.reBuild();
  //       }, 300);
  //       console.log("All Images first",data);
  //     } catch (error) {
  //       console.log("An error occurred:", error);
  //     }
  //   };
  //   fetchData();
  // }, []);


  // useEffect(() => {

  //   const fetchData = async () => {
  //     try {
  //       const response = await fetch("http://localhost:8000/api/frontend/get-all-projects");
  //       const data = await response.json();
  //       setMadhyaImages(data);
  //       setTimeout(() => {
  //         window.dispatchEvent(new Event('resize'));
  //         if (window.fullpage_api) window.fullpage_api.reBuild();
  //       }, 300);
  //       console.log("All Images second",data);
  //     } catch (error) {
  //       console.log("An error occurred:", error);
  //     }
  //   };
  //   fetchData();
  // }, []);


// useEffect(() => {

//   const fetchData = async () => {
//     try {
//       const response = await fetch("http://localhost:8000/api/frontend/get-all-projects");
//       const data = await response.json();

//       // Filter to get only distinct titles
//       const seenTitles = new Set();
//       const distinctData = data.filter(item => {
//         if (!seenTitles.has(item.title)) {
//           seenTitles.add(item.title);
//           return true;
//         }
//         return false;
//       });

//       setMadhyaImages(distinctData);

//       setTimeout(() => {
//         window.dispatchEvent(new Event('resize'));
//         if (window.fullpage_api) window.fullpage_api.reBuild();
//       }, 300);

//       console.log("Distinct Images", distinctData);
//     } catch (error) {
//       console.log("An error occurred:", error);
//     }
//   };

//   fetchData();

// }, []);

/*HHHHHHHHHHHHHHHHHHH*/

useEffect(() => {
  const fetchData = async () => {
    try {
      const response = await fetch("/api/frontend/get-all-projects");
      const data = await response.json();

      // Filter to get only distinct titles
      const seenTitles = new Set();
      const distinctData = data.filter(item => {
        if (!seenTitles.has(item.title)) {
          seenTitles.add(item.title);
          return true;
        }
        return false;
      });

      console.log("All Images first", distinctData);

      setMadhyaImages(distinctData);
      
      let deskCount=0, mobCount=0;
      distinctData[distinctData.length-1].images.map((img)=> {
      (img.desk_img && img.desk_img!="") && deskCount++;
      (img.mob_img && img.mob_img!="") && mobCount++;
     })
      console.log("desk: ",deskCount, "mob: ",mobCount);
      dispatch(handleDesktopImageCount(deskCount));
      dispatch(handleMobileImageCount(mobCount));

      // Rebuild fullpage and trigger resize
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
        if (window.fullpage_api) window.fullpage_api.reBuild();
      }, 300);

    } catch (error) {
      console.log("An error occurred:", error);
    }
  };

  fetchData();
}, []);

/*HHHHHHHHHHHHHHHHHHH*/

// useEffect(() => {
//   const fetchData = async () => {
//     try {
//       const response = await fetch("http://localhost:8000/api/frontend/get-all-data");
//       const data = await response.json();

//       // Filter to get only distinct titles
//       const seenTitles = new Set();
//       const distinctData = data.filter(item => {
//         if (!seenTitles.has(item.title)) {
//           seenTitles.add(item.title);
//           return true;
//         }
//         return false;
//       });

//       // Set the distinct data if needed
//       // setMadhyaImages(distinctData);

//       // Just to match your format:
//       console.log("All Images first", distinctData);
//       setMadhyaImages(distinctData);
//       // Rebuild fullpage and trigger resize
//       setTimeout(() => {
//         window.dispatchEvent(new Event('resize'));
//         if (window.fullpage_api) window.fullpage_api.reBuild();
//       }, 300);

//     } catch (error) {
//       console.log("An error occurred:", error);
//     }
//   };

//   fetchData();
// }, []);



// useEffect(() => {
//   const fetchData = async () => {
//     try {
//       const response = await fetch("http://localhost:8000/api/frontend/get-all-projects");
//       const data = await response.json();

//       const seenTitleCategoryPairs = new Set();
//       const filteredData = [];

//       data.forEach(item => {
//         item.categories.forEach(category => {
//           const key = `${item.title}::${category}`;
//           if (!seenTitleCategoryPairs.has(key)) {
//             seenTitleCategoryPairs.add(key);
//             filteredData.push(item);
//           }
//         });
//       });

//       console.log("GGGGGGGGGGGG: ",filteredData);

//       setMadhyaImages(filteredData);

//       setTimeout(() => {
//         window.dispatchEvent(new Event('resize'));
//         if (window.fullpage_api) window.fullpage_api.reBuild();
//       }, 300);

//       console.log("Distinct Images by Category", filteredData);
//     } catch (error) {
//       console.log("An error occurred:", error);
//     }
//   };

//   fetchData();
// }, []);



// useEffect(() => {
//   const fetchData = async () => {
//     try {
//       const response = await fetch("http://localhost:8000/api/frontend/get-all-projects");
//       const data = await response.json();

//       const seenCategories = new Set();
//       const distinctCategoryItems = [];

//       data.forEach(item => {
//         // Assume item.categories is an array like ["Furniture Design"]
//         const categoryKey = item.categories.join(','); // Combine in case there are multiple

//         if (!seenCategories.has(categoryKey)) {
//           seenCategories.add(categoryKey);
//           distinctCategoryItems.push(item);
//         }
//       });

//       console.log("All Images first", distinctCategoryItems);

//       setMadhyaImages(distinctCategoryItems);

//       setTimeout(() => {
//         window.dispatchEvent(new Event('resize'));
//         if (window.fullpage_api) window.fullpage_api.reBuild();
//       }, 300);

//     } catch (error) {
//       console.log("An error occurred:", error);
//     }
//   };

//   fetchData();
// }, []);





  useEffect(() => {
    if (initialPageNo.length > 0) {
      dispatch(allPagesNumbers(initialPageNo));
    }
  }, [initialPageNo, dispatch]);


  useEffect(()=> {
     console.log("INITIAL PAGE NUMBER",initialPageNo)
  },[initialPageNo])

  // moveTo when all dependencies are ready
  useEffect(() => {
    if (fullpageInstance && madhyaImages.length > 0 && pageNumber) {
      setTimeout(() => {
        fullpageInstance.moveTo(pageNumber);
      }, 100);
    }
  }, [fullpageInstance, madhyaImages, pageNumber]);


  return (
    <ReactFullpage
      licenseKey={'514'}
      scrollingSpeed={900}
      render={({ state, fullpageApi }) => {
        if (!fullpageInstance && fullpageApi) {
          setFullpageInstance(fullpageApi);
        }

        return (
          <ReactFullpage.Wrapper>
            <div className="section">
              <p className="company-logo">
                <b>A division of</b>&nbsp;&nbsp;<span>mayabious group</span>
              </p>
            </div>

            <div className="section">
              <img src='/assets/desk/2.jpg' alt='no-img' className='desktop-img' />
              <img src='/assets/mob/2.jpg' alt='no-img' className='mobile-img' />
            </div>

            <div className="section">
              <img src='/assets/ethos-desktop.jpg' alt='no-img' className='desktop-img' />
              <img src='/assets/ethos-mob.jpg' alt='no-img' className='mobile-img' />
              <h3 className="ethos">
                At Madhya Design, we firmly believe in the role of nurturing our bond
                with nature. We, as human beings, often take more than what we give
                back, creating a imbalance in the ecosystem. Urbanization, in
                particular, has been developed with the resources used unmindfully.
                But here at Madhya Design, our principle is based on the words “Art Of
                Balance We Live In”. As an architectural firm, we are aiming to
                rebuild the lost balance between human needs and nature. Our designs
                are the saga of harmonious relationships bridging the gap between
                modernity and greenery. We firmly adhere to some ethos while giving
                our ideas a shape on the screen.
              </h3>
            </div>

            {madhyaImages.map((part, index) => (
              <ImageSection
                key={index}
                part={part}
                onChildData={(pageNum) => setInitialPageNo(pageNum)}
              />
            ))}

            <div className="section">
              <h1 className="heading">Impact</h1>
              <p className="text-center" style={{ fontSize: "22px" }}>
                Coming Soon...
              </p>
            </div>

           <TeamMember className="section"/>

            {/* <div className="section slider-sec">
              <h1>TEAM</h1>
              <Slider {...sliderSettings} className='team-slider'>
                {
                  teamMembers.map((member) => {
                    const { id, name, image, designation, content } = member;
                    return (
                      <div className='team' key={id}>
                        <div className="image">
                          <div className="img">
                            <img src={`http://localhost:8000/upload/${image}`} alt='no-img' className='img-fluid' />
                            <div className="info">
                              <h4>{name}</h4>
                              <p className='text-center'>{designation}</p>
                            </div>
                          </div>
                          <p className="desc">
                            {activeIndex === id ? content : content?.split(' ').slice(0, 3).join(' ')}
                            <a href="#" style={{ textDecoration: "none" }} onClick={() => handleExpendText(id)}>
                              {activeIndex === id ? " Read Less" : "...Read More"}
                            </a>
                          </p>
                          <div className="social-icons">
                            <a href="#"><i className="fa-brands fa-facebook-f"></i></a>
                            <a href="#"><i className="fa-brands fa-linkedin-in"></i></a>
                            <a href="#"><i className="fa-brands fa-instagram"></i></a>
                          </div>
                        </div>
                      </div>
                    );
                  })
                }
              </Slider>
            </div> */}

            {/* <div className="section">
              <div className="container">
                <div className="footer_get_touch_inner grid-70-30">
                  <div className="colmun-70 get_form">
                    <div className="get_form_inner">
                      <div className="get_form_inner_text">
                        <h3>Get In Touch</h3>
                      </div>
                      <form onSubmit={handleFormSubmit}>
                        <div className="grid-50-50">
                          <input type="text" name="firstName" placeholder="First Name" value={userInfo.firstName} onChange={handleInputChange} required />
                          <input type="text" name="lastName" placeholder="Last Name" value={userInfo.lastName} onChange={handleInputChange} required />
                          <input type="email" name="email" placeholder="Email" value={userInfo.email} onChange={handleInputChange} required />
                          <input type="tel" name="phone" placeholder="Phone/Skype" value={userInfo.phone} onChange={handleInputChange} required />
                        </div>
                        <div className="grid-full">
                          <textarea name="message" placeholder="About Your Project" value={userInfo.message} onChange={handleInputChange} rows="10" required></textarea>
                          <input type="submit" value="Submit" />
                        </div>
                      </form>
                    </div>
                  </div>
                  <div className="colmun-30 get_say_form">
                    <h5>Let's Connect!</h5>
                    <ul className="get_say_info_sec">
                      <li><i className="fa fa-envelope"></i><a href={`mailto:${formData.email}`} target='_blank'>{formData.email}</a></li>
                      <li><i className="fa-brands fa-whatsapp"></i><a href={`tel:${formData.phoneno}`} target='_blank'>{formData.phoneno}</a></li>
                    </ul>
                    <ul className="get_say_social-icn">
                      <li><a href={`${formData.fb_link}`} target='_blank'><i className="fa-brands fa-facebook-f"></i></a></li>
                      <li><a href={`${formData.insta_link}`} target='_blank'><i className="fa-brands fa-instagram"></i></a></li>
                      <li><a href={`${formData.twitter_link}`} target='_blank'><i class="fa-brands fa-x-twitter"></i></a></li>
                      <li><a href={`${formData.linked_in_link}`} target='_blank'><i className="fa-brands fa-linkedin-in"></i></a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div> */}

            <GetInTouch className="section" />

          </ReactFullpage.Wrapper>
        );
      }}
    />
  );
};

export default Fullpage;
 